export { loggingAction } from 'next-flight-server-reference-proxy-loader?id=7fded1647c7b8c7a46b40f382d726a2616fc8f5973&name=loggingAction!'